export default import.meta.ROLLDOWN_FILE_URL_hrtGJG1mSjgciWE7K3mjig